import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Accordion, Col, Container, Row, Form, InputGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Context } from '../Components/Context';
import Instructions from '../Components/Instructions';
import Attestation from '../Components/Attestation';
import DependentsTable from '../Components/DependentsTable';
import OtherDependentsTable from '../Components/OtherDependentsTable';
import Api from '../Services/api/api';
import GuardiansForm from '../Components/GuardiansForm';

const Application = () => {
    const { applicants, counties, effectiveDate, selectedCounty, selectedPlan, setIsSubmitted } = useContext(Context);

    const [state, setState] = useState({
        plans: [],
        minorCheckbox: false,
        primaryFullName: '',
        primaryLastName: '',
        primaryFirstName: '',
        primaryMiddleName: '',
        validated: false,
        address: { address: '', apartment: '', city: '', state: 'FL', zip: '' },
        mailingAddress: { address: '', apartment: '', city: '', county: '', state: '', zip: '' },
    });

    const navigate = useNavigate();

    // On load
    useEffect(() => {
        if (!applicants?.length || !applicants[0]?.sex) {
            navigate('/');
        }
        else if (!selectedPlan?.id) {
            navigate('/PlanSelect');
        }

        Api.getPlans(effectiveDate)
            .then(res => {
                setState({
                    ...state,
                    plans: res
                })
            })
            .catch(err => console.log(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAddressChange = (e) => {
        setState({ ...state, address: { ...state.address, [e.target.getAttribute('field')]: e.target.value } });
    }

    const handleMailingAddressChange = (e) => {
        setState({ ...state, mailingAddress: { ...state.mailingAddress, [e.target.getAttribute('field')]: e.target.value } });
    }

    const handleMinorChange = (event) => {
        setState({ ...state, [event.target.id]: event.target.checked });
    }

    const handleChange = (event) => {
        let primaryFullName = state.primaryFullName;
        if (event.target.id === 'primaryFirstName' || event.target.id === 'primaryLastName' || event.target.id === 'primaryMiddleName') {
            let { primaryFirstName, primaryMiddleName, primaryLastName } = state;
            let name = { primaryFirstName, primaryMiddleName, primaryLastName, [event.target.id]: event.target.value };

            primaryFullName = `${name.primaryLastName}, ${name.primaryFirstName}, ${name.primaryMiddleName.substring(0, 1)}`;
        }

        setState({
            ...state,
            [event.target.id]: event.target.value,
            primaryFullName: primaryFullName
        });
    }

    const handleGroupCoverageChange = (event) => {
        if (event.target.value === 'Yes') {
            document.getElementById('otherInsuranceGroupCoverageSection').removeAttribute('hidden');
        } else {
            document.getElementById('otherInsuranceGroupCoverageSection').setAttribute('hidden', '');
        }
    }

    const openAllAccordions = () => {
        // open accordions
        const getCollapsedAccordionSections = document.getElementsByClassName("collapse");
        for (let i = 0; i < getCollapsedAccordionSections.length; i++) {
            getCollapsedAccordionSections[i].classList.add("show")
        }
        // set accordion button as opened
        var getAccordionButtons = document.getElementsByClassName("accordion-button");
        for (let i = 0; i < getAccordionButtons.length; i++) {
            getAccordionButtons[i].classList.remove("collapsed");
            getAccordionButtons[i].setAttribute("aria-expanded", "true");
        }
    }

    const handleSubmitValidate = (event) => {
        // open all accordions        
        openAllAccordions();
        
        const form = document.forms[0];

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();

            // scroll to first invalid element
            let elementsArray = document.querySelectorAll('input,select,textarea');
            let elements = [...elementsArray].reverse();
            
            for (var i = elements.length; i--;) {
                if (elements[i].id) {
                    let elem = document.getElementById(elements[i].id);
                    
                    if (elem.validity.valid === false) {
                        elem.scrollIntoView({ behavior: 'smooth' });
                        break;
                    }  
                }
            }            
            alert("Please complete required fields");
        } else {
            //All required feilds are complete, submit form
            handleSubmit(event);
        }
        // turn on validation status
        setState({ ...state, validated: true });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        // get form object
        const form = document.forms[0];
        const inputs = form.querySelectorAll(['input', 'select', 'textarea']);
        // Iterate over your inputs and set the input name as your
        // property key, and the value as its value
        var jsonData = {};
        var inputs_array = [...inputs]; // converts NodeList to Array
        inputs_array.forEach(el => {
            // Handle radio buttons, only add the checked one to the json
            if (el.type === 'radio' && el.checked) {
                var radioName = el.name;
                jsonData[radioName] = el.value;
            } else {
                //Handle all other inputs
                var columnName = el.id;
                if (!!columnName) {
                    jsonData[columnName] = el.value;

                    if (columnName === "planNumber") {
                        // set value for hiosNumber and planName for selected plan
                        var copyPlans = [...state.plans];

                        const plan = copyPlans.find((item) => item.planNumber === +el.value);

                        jsonData["planName"] = plan.planName;
                        jsonData["planHiosNumber"] = plan.id;
                    }
                }
            }
        });

        Api.submitEnrollmentForm(jsonData)
            .then((response) => {
                setIsSubmitted(true);
                navigate('/Completed');
                clearForm();
            })
            .catch((err) => {
                console.log(err.message);
                // TODO Provide feedback that operation failed
            });
    }

    const clearForm = (event) => {
        document.getElementById("enrollmentform").reset();
        setState({
            ...state,
            address: { address: '', apartment: '', city: '', state: '', zip: '' },
            mailingAddress: { address: '', apartment: '', city: '', county: '', state: '', zip: '' },
            validated: false,
            primaryFullName: ''
        });
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }

    const formatNumberInput = (e) => {
        // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
        let checkIfNum;
        if (e.key !== undefined) {
            // Check if it's a "e", ".", "+" or "-"
            checkIfNum = e.key === "e" || e.key === "+";
        }
        else if (e.keyCode !== undefined) {
            // Check if it's a "e" (69), "." (190), "+" (187) or "-" (189)
            checkIfNum = e.keyCode === 69 || e.keyCode === 187;
        }
        return checkIfNum && e.preventDefault();
    }

    var date = new Date();
    date.setDate(date.getDate());

    const enableCheckbox = () => {
        document.getElementById("conditionsElectronicSigningBox").disabled = false;
    }

    return (
        <section className='survey-forms'>
            <Container>
                <h2 className="mb-2">Individual Coverage Application</h2>

                <h6>For Off-Marketplace Plans—For New and Renewing Coverage</h6>

                <div className="fs-smaller rounded bg-warning bg-opacity-25 p-2">
                    <Instructions id="instructionsBasic" className="me-2 btn-sm" />
                    This application must be completed in its entirety or processing time may be delayed. Applicants must reside within the Health First Health Plans service area to be eligible for coverage.
                </div>
                
                <Form id="enrollmentform" noValidate validated={state.validated} onSubmit={handleSubmitValidate}>
                    <Row>
                        <Col sm={12}>
                            <Accordion id="parentAccordion" defaultActiveKey="0" alwaysOpen>
                                {/*Section 1: Primary Applicant Information*/}
                                <Accordion.Item key="0" eventKey="0">
                                    <Accordion.Header>SECTION 1: PRIMARY APPLICANT INFORMATION</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col xl={12}>
                                                <Form.Check className='mb-3'
                                                    type="checkbox"
                                                    id="minorCheckbox"
                                                    value={state.minorCheckbox}
                                                    onChange={handleMinorChange}
                                                    label="Check this box if primary applicant is a minor."
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={6}>
                                                <Form.Group controlId="primaryLastName">
                                                    <Form.Label>Primary Applicant's Last Name *</Form.Label>
                                                    <Form.Control type="text" className='mb-2' required onChange={handleChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={4}>
                                                <Form.Group controlId="primaryFirstName">
                                                    <Form.Label>First Name *</Form.Label>
                                                    <Form.Control type="text" className='mb-2' required onChange={handleChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryMiddleName">
                                                    <Form.Label>Middle Name</Form.Label>
                                                    <Form.Control type="text" className='mb-2' onChange={handleChange} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={6}>
                                                <Form.Group controlId="primaryMaritalStatus">
                                                    <Form.Label>Marital Status *</Form.Label>
                                                    <Form.Select className='mb-2' required>
                                                        <option hidden value="">Choose Marital Status</option>
                                                        <option value="single">Single</option>
                                                        <option value="married">Married</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col xl={6}>
                                                <Form.Group controlId="primaryLanguage">
                                                    <Form.Label>Language *</Form.Label>
                                                    <Form.Select className='mb-2' required>
                                                        <option hidden value="">Choose Language</option>
                                                        <option value="english">English</option>
                                                        <option value="spanish">Spanish</option>
                                                        <option value="other">Other</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={5}>
                                                <Form.Group controlId="primaryHomeAddress">
                                                    <Form.Label>Home Address (No P.O. Box): Street *</Form.Label>
                                                    <Form.Control className='mb-2' type="text" rows={3} field='address' value={state.address.address} onChange={handleAddressChange} required />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={1}>
                                                <Form.Group controlId="primaryApartment">
                                                    <Form.Label>Apartment</Form.Label>
                                                    <Form.Control type="text" className='mb-2' field='apartment' value={state.address.apartment} onChange={handleAddressChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryCity">
                                                    <Form.Label>City *</Form.Label>
                                                    <Form.Control type="text" className='mb-2' field='city' value={state.address.city} onChange={handleAddressChange} required />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryCounty">
                                                    <Form.Label>County *</Form.Label>
                                                    <Form.Select className='mb-2' field='county' value={selectedCounty} readOnly required disabled>
                                                        <option hidden value="">Select County</option>
                                                        {counties.map((option) =>
                                                            <option value={option} key={option}>{option}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col xl={1}>
                                                <Form.Group controlId="primaryState">
                                                    <Form.Label>State *</Form.Label>
                                                    <Form.Control type="text" className='mb-2' readOnly field='state' value={state.address.state} onChange={handleAddressChange} required />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={1}>
                                                <Form.Group controlId="primaryZip">
                                                    <Form.Label>Zip *</Form.Label>
                                                    <Form.Control type="number" className='mb-2' field='zip' value={state.address.zip} onChange={handleAddressChange} onKeyDown={formatNumberInput} required />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={5}>
                                                <Form.Group controlId="primaryMailingAddress">
                                                    <Form.Label>Mailing Address (No P.O. Box): Street (if different than above)</Form.Label>
                                                    <Form.Control className='mb-2' type="text" rows={3} field='address' value={state.mailingAddress.address} onChange={handleMailingAddressChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={1}>
                                                <Form.Group controlId="primaryMailingApartment">
                                                    <Form.Label>Apartment</Form.Label>
                                                    <Form.Control type="text" className='mb-2' field='apartment' value={state.mailingAddress.apartment} onChange={handleMailingAddressChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryMailingCity">
                                                    <Form.Label>City</Form.Label>
                                                    <Form.Control type="text" className='mb-2' field='city' value={state.mailingAddress.city} onChange={handleMailingAddressChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryMailingCounty">
                                                    <Form.Label>County</Form.Label>
                                                    <Form.Control type="text" className='mb-2' field='county' value={state.mailingAddress.county} onChange={handleMailingAddressChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={1}>
                                                <Form.Group controlId="primaryMailingState">
                                                    <Form.Label>State</Form.Label>
                                                    <Form.Control type="text" className='mb-2' field='state' value={state.mailingAddress.state} onChange={handleMailingAddressChange} />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={1}>
                                                <Form.Group controlId="primaryMailingZip">
                                                    <Form.Label>Zip</Form.Label>
                                                    <Form.Control type="number" className='mb-2' field='zip' value={state.mailingAddress.zip} onChange={handleMailingAddressChange} onKeyDown={formatNumberInput} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryPrimaryPhone">
                                                    <Form.Label>Primary Phone *</Form.Label>
                                                    <Form.Control type="tel" className='mb-2' required />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryWorkPhone">
                                                    <Form.Label>Work Phone</Form.Label>
                                                    <Form.Control type="tel" className='mb-2' />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={2}>
                                                <Form.Group controlId="primaryCellPhone">
                                                    <Form.Label>Cell Phone</Form.Label>
                                                    <Form.Control type="tel" className='mb-2' />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={3}>
                                                <Form.Group controlId="primaryOtherPhone">
                                                    <Form.Label>Other</Form.Label>
                                                    <Form.Control type="tel" className='mb-2' />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={3}>
                                                <Form.Group controlId="primaryBestTimeToCall">
                                                    <Form.Label>Best time to call</Form.Label>
                                                    <Form.Select className='mb-2'>
                                                        <option hidden value="">Choose Best time to call</option>
                                                        <option value="AM">AM</option>
                                                        <option value="PM">PM</option>
                                                        <option value="Any">Any</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={6}>
                                                <Form.Group controlId="primaryEmail">
                                                    <Form.Label>Email Address</Form.Label>
                                                    <Form.Control type="email" className='mb-2 col' placeholder="sample.email@domain.com" />
                                                </Form.Group>
                                            </Col>
                                            <Col xl={6}>
                                                <div className="fs-xsmaller col rounded bg-warning bg-opacity-25 mt-4 ms-2 p-1" >By providing my email address, I am authorizing Health First Health Plans to send any and all communications regarding this Application via secure email.</div>
                                            </Col>
                                        </Row>
                                        {state.minorCheckbox && (
                                            <GuardiansForm
                                                address={{ ...state.address, county: selectedCounty }}
                                                mailingAddress={state.mailingAddress}
                                            />
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="1" eventKey="1">
                                    <Accordion.Header>SECTION 2: ADDITIONAL APPLICANT INFORMATION</Accordion.Header>
                                    <Accordion.Body>
                                        <DependentsTable applicants={applicants} primaryFirstName={state.primaryFirstName} primaryLastName={state.primaryLastName} primaryMiddleName={state.primaryMiddleName} primaryFullName={state.primaryFullName} counties={counties} />
                                        {selectedPlan?.applicants?.some(x => x.age < 18) && (
                                            <Row>
                                                <Col xl={12}>
                                                    <Form.Group className="bg-warning bg-opacity-25 p-2 row">
                                                        <Row>
                                                            <Form.Check value="true" id="dependentsAttestationBox" className="checkbox-lg col-1 d-flex centered" required />
                                                            <Form.Label className="col" >I attest that the children listed on this application are the legal dependents of the primary applicant.</Form.Label>
                                                        </Row>
                                                    </Form.Group>
                                                </ Col>
                                            </Row>
                                        )}
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="2" eventKey="2">
                                    <Accordion.Header>SECTION 3: PLAN SELECTION</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col sm={12}>
                                                <p className='mb-2'>
                                                    <span className='fw-medium'>Medical plan</span> -All medical plans are compliant with the Affordable Care Act and cover all required Essential Health
                                                    Benefits, including Pediatric Dental and Vision. Please mark your plan choice:
                                                </p>
                                            </Col>
                                            <Col xl={6}>
                                                <Form.Group controlId="planNumber">
                                                    <Form.Label>Select Plan</Form.Label>
                                                    <Form.Select className='mb-2' value={selectedPlan.planNumber} readOnly required disabled>
                                                        <option hidden value="">Select Plan</option>
                                                        {state.plans.map((option) => <option value={option.planNumber} key={option.planNumber}>{option.planName}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col xl={3}>
                                                <Form.Label htmlFor="planTotalPremium">Total Premium</Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text>$</InputGroup.Text>
                                                    <Form.Control id="planTotalPremium" type="number" placeholder="Total premium" step="0.01" value={selectedPlan.rate} readOnly required disabled />
                                                </InputGroup>
                                            </Col>
                                            <Col sm={12}>
                                                <div className="bg-warning bg-opacity-25 p-2 mb-2">
                                                    <h6>Requested effective date</h6> <p className="mb-0">(Health First will attempt to provide you with the requested effective date however the requested effective date is not guaranteed.)</p>
                                                </div>
                                                <Col sm={2}>
                                                    <Form.Group controlId="planEffectiveMonth">
                                                        <Form.Control type="date" value={effectiveDate} readOnly required disabled></Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="3" eventKey="3">
                                    <Accordion.Header>SECTION 4: PRIOR/OTHER COVERAGE</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col sm={12}>
                                                <ol type='A' className='ps-3 m-0 list-question ol-dark'>
                                                    <li className='question-item'>
                                                        <span>Have any of the applicants ever been a member of an Individual or Group Plan with Health First?</span>
                                                        <Row>
                                                            <Col xl={10}>
                                                                <Form.Group controlId="previousHFCoverage">
                                                                    <Form.Label className='fw-medium fst-italic'>If yes, please provide the member’s name and Policy number:</Form.Label>
                                                                    <Form.Control className='mb-2' as="textarea" rows={3} />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </li>
                                                    <li className='question-item'>
                                                        <span>Have any of the applicants had health insurance coverage that has ended within the last 60 days?</span>
                                                        <Row>
                                                            <Col xl={10}>
                                                                <Form.Group controlId="previousCoverageEndLast60Days">
                                                                    <Form.Label className='fw-medium fst-italic'>If yes, please provide Applicant’s name, insurance company’s information, type of coverage, effective date,
                                                                        and termination date:</Form.Label>
                                                                    <Form.Control className='mb-2' as="textarea" rows={3} />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </li>
                                                    <li className='question-item'>
                                                        <span>Do any of the applicants currently have health insurance coverage?</span>
                                                        <Row>
                                                            <Col sm={12}>
                                                                <Form.Group onChange={handleGroupCoverageChange}>
                                                                    <Form.Check
                                                                        inline
                                                                        label='No'
                                                                        name='otherInsuranceGroupCoverage'
                                                                        id='noOtherCoverage'
                                                                        type='radio'
                                                                        value='No' defaultChecked
                                                                    />
                                                                    <Form.Check
                                                                        inline
                                                                        label='Yes'
                                                                        name='otherInsuranceGroupCoverage'
                                                                        id='yesOtherCoverage'
                                                                        type='radio'
                                                                        value='Yes'
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row className="mt-3" id="otherInsuranceGroupCoverageSection" hidden>
                                                            <Col xl={12}>
                                                                <Form.Group controlId="noOtherCoverageAttestationInitials">
                                                                    <Form.Label className='fw-medium'>Complete this section only if the primary applicant or dependents have other health coverage that will not be cancelled when coverage under this application becomes effective. If primary applicant and/or dependents will not have other coverage, please initial:</Form.Label>
                                                                    <Form.Control type="text" className='mb-2 w-25' placeholder='Initial i.e.(AZ)' />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={12}>
                                                                <Form.Group controlId="otherInsuranceDependents">
                                                                    <Form.Label>List the names of each individual covered under Other Insurance Carrier</Form.Label>
                                                                    <Form.Control className='mb-2' as="textarea" placeholder='Enter Other Insurance Carrier' rows={3} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={12}>
                                                                <Form.Group controlId="otherInsuranceAddress">
                                                                    <Form.Label>Name and Address of Other Insurance Carrier</Form.Label>
                                                                    <Form.Control className='mb-2' as="textarea" placeholder='Enter Name and Address of Other Insurance Carrier' rows={3} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={3}>
                                                                <Form.Group controlId="otherInsuranceEffectiveDate">
                                                                    <Form.Label>Effective Date</Form.Label>
                                                                    <Form.Control type="date" className='mb-2' />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={3}>
                                                                <Form.Group controlId="otherInsuranceTypePolicy">
                                                                    <Form.Label>Type of Policy</Form.Label>
                                                                    <Form.Select className='mb-2'>
                                                                        <option hidden value="">Choose Policy</option>
                                                                        <option value="employee only">Employee Only</option>
                                                                        <option value="employee/spouse">Employee/Spouse</option>
                                                                        <option value="employee/child(ren)">Employee/Child(ren)</option>
                                                                        <option value="family">Family</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={6}>
                                                                <Form.Group controlId="otherInsurancePolicyholder">
                                                                    <Form.Label>Name of Policyholder (First, Last)</Form.Label>
                                                                    <Form.Control type="text" className='mb-2' placeholder='Enter Name of Policyholder' />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={3}>
                                                                <Form.Group controlId="otherInsuranceHolderDOB">
                                                                    <Form.Label>Birth Date</Form.Label>
                                                                    <Form.Control type="date" className='mb-2' />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={3}>
                                                                <Form.Group controlId="otherInsuranceHolderSex">
                                                                    <Form.Label>Sex</Form.Label>
                                                                    <Form.Select className='mb-2'>
                                                                        <option hidden value="">Choose Sex</option>
                                                                        <option value="male">Male</option>
                                                                        <option value="female">Female</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={3}>
                                                                <Form.Group controlId="otherInsuranceRelationToApplicant">
                                                                    <Form.Label>Relationship to Applicant</Form.Label>
                                                                    <Form.Select className='mb-2'>
                                                                        <option hidden value="">Choose Relationship</option>
                                                                        <option value="self">Self</option>
                                                                        <option value="spouse">Spouse</option>
                                                                        <option vale="dependent">Dependent</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={3}>
                                                                <Form.Group controlId="otherInsuranceEmpName">
                                                                    <Form.Label>Employer's Name</Form.Label>
                                                                    <Form.Control type="text" className='mb-2' placeholder="Enter Employer's Name" />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={4}>
                                                                <Form.Group controlId="otherInsuranceStartDate">
                                                                    <Form.Label>Start Date</Form.Label>
                                                                    <Form.Control type="date" className='mb-2' />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={4}>
                                                                <Form.Group controlId="otherInsuranceGroupNumber">
                                                                    <Form.Label>Group Number</Form.Label>
                                                                    <Form.Control type="text" className='mb-2' placeholder='Enter Group Number' />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xl={4}>
                                                                <Form.Group controlId="otherInsurancePolicyNumber">
                                                                    <Form.Label>Policy Number</Form.Label>
                                                                    <Form.Control type="text" className='mb-2' placeholder='Enter Policy Number' />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={12}>
                                                                <OtherDependentsTable />
                                                            </Col>
                                                            <Col sm={12}>
                                                                <div className="bg-warning bg-opacity-25 p-2">
                                                                    <p className='mb-1'>B. Enter 'B' when this dependent is covered under both you and your spouse’s insurance plan (married).</p>
                                                                    <p className='mb-1'>S. Enter 'S' if you are the parent awarded custody of this dependent and no other individual is required to pay for this dependent’s medical expenses.</p>
                                                                    <p className='mb-1'>F. Enter 'F' if this dependent is covered by another individual (not a member of your household) required to pay for this dependent’s medical expenses.</p>
                                                                </div>
                                                            </Col>
                                                            <Col xl={12}>
                                                                <Form.Group>
                                                                    <Form.Label className='fw-medium'>I understand that any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application containing any false,
                                                                        incomplete or misleading information is guilty of a felony of the third degree.</Form.Label>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </li>
                                                </ol>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="4" eventKey="4">
                                    <Accordion.Header>SECTION 5: CONDITIONS OF ENROLLMENT</Accordion.Header>
                                    <Accordion.Body>
                                        <Form.Group className="bg-warning bg-opacity-25 p-2 mb-3">
                                            <div onClick={enableCheckbox}>
                                                <Attestation />
                                            </div>
                                            <Row>
                                                <p className="fs-smaller mb-2">ACKNOWLEDGEMENT and AGREEMENT: The primary applicant understands and agrees to abide by all terms, conditions and provisions of the Contract. The primary applicant has read and understands this Application including the conditions of enrollment. The primary applicant understands if this Application is accepted it will become part of the Contract. My signature (either signed below or electronically submitted) indicates the acceptance of these terms and that the information entered in this Application is complete, true and correct.</p>
                                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-disabled">Read Attestation first</Tooltip>}>
                                                    <span className="col-12 d-inline-block">
                                                        <Row>
                                                            <Col xl={1}>
                                                                <Form.Check value="true" id="conditionsElectronicSigningBox" className="checkbox-lg d-flex centered" disabled={true} required />
                                                            </Col>
                                                            <Col xl={11}>
                                                                <Form.Label htmlFor="conditionsElectronicSigningBox" className="fs-smaller" >By checking this box and entering the Primary Applicant's name below, I am indicating intent to electronically sign this Application and warrant that all the information provided is true, complete and accurate. I acknowledge that the required forms have been provided during the application process.</Form.Label>
                                                            </Col>
                                                        </Row>
                                                    </span>
                                                </OverlayTrigger>
                                            </Row>
                                        </Form.Group>

                                        <Col xl={5}>
                                            <Row>
                                                <Form.Group controlId="enrollmentConditionsPrimaryName">
                                                    <Form.Label className='fw-medium align-items-center'>Primary Applicant:</Form.Label>
                                                    <Form.Control type="text" className='mb-2' placeholder='Applicant Name' required />
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="5" eventKey="5">
                                    <Accordion.Header>SECTION 6: ACKNOWLEDGMENT</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="fs-smaller">IT IS IMPORTANT THE PRIMARY APPLICANT REVIEWS AND UNDERSTANDS THE FOLLOWING. By submitting an application for benefits, the primary applicant agrees with all of the statements listed below:</div>
                                        <ul className="fs-smaller">
                                            <li>I attest the information submitted in this Application is true and accurate to the best of my knowledge. Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application containing any false, incomplete, or misleading information is guilty of a felony of the third degree.</li>
                                            <li>Once benefits are effective, they are contingent on timely and accurate payment of premiums and any other cost sharing as outlined in the policy. If payment is not accurate and paid on time, my coverage will be terminated. If terminated for non-payment, I may no longer be eligible to enroll in Health First Health Plans.</li>
                                        </ul>
                                        <Form.Group className="bg-warning bg-opacity-25 p-2 mb-3">
                                            <Row>
                                                <span className="fw-medium  fs-smaller" >Authorization for electronic signature</span>
                                                <Form.Check value="true" id="acknowledgementElectronicSigningBox" className="checkbox-lg col-1 d-flex centered" required />
                                                <Form.Label className="col fs-smaller" >By checking this box and entering the Primary Applicant's name below, I am indicating intent to electronically sign this Application and warrant that all the information provided is true, complete and accurate. I acknowledge that the required forms have been provided during the application process.</Form.Label>
                                            </Row>
                                        </Form.Group>
                                        <Col xl={5}>
                                            <Row>
                                                <Form.Group>
                                                    <Row>
                                                        <Form.Group controlId="acknowledgementConditionsPrimarySignature">
                                                            <Form.Label className='fw-medium align-items-center'>Primary Applicant:</Form.Label>
                                                            <Form.Control type="text" className='mb-2' placeholder='Applicant Name' required />
                                                        </Form.Group>
                                                    </Row>
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="6" eventKey="6">
                                    <Accordion.Header>SECTION 7: STATEMENT OF ACCOUNTABILITY</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="fs-smaller">
                                            <p>I have personally read and completed the Individual Application for the applicant because:</p>
                                            <ul>
                                                <li>Applicant is a minor and I am the applicant’s parent or legal guardian.</li>
                                                <li>Applicant has limited English proficiency and is unable to complete this application.</li>
                                                <li>The Applicant is legally incapacitated and unable to complete this application.</li>
                                            </ul>
                                        </div>
                                        <Form.Group className="bg-warning bg-opacity-25 p-2 mb-3">
                                            <Row>
                                                <Form.Check value="true" id="accountabilityElectronicInitials" className="checkbox-lg col-1 d-flex centered" />
                                                <Form.Label className="col fs-smaller" >I have read and explained in detail the contents of this Application. If translated, I translated the contents of this form and to the best of my knowledge obtained and listed all the requested personal information disclosed by</Form.Label>
                                            </Row>
                                        </Form.Group>
                                        <Col xl={5}>
                                            <Row>
                                                <Form.Group>
                                                    <Row>
                                                        <Form.Group controlId="accountabilityConditionsPrimarySignature">
                                                            <Form.Label className='fw-medium align-items-center'>Proxy's Name:</Form.Label>
                                                            <Form.Control type="text" className='mb-2' placeholder='Proxy Name:' />
                                                        </Form.Group>
                                                    </Row>
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item key="7" eventKey="7">
                                    <Accordion.Header>SECTION 8: INSURANCE PRODUCER INFORMATION</Accordion.Header>
                                    <Accordion.Body>
                                        <Col xl={12}>
                                            <Form.Group className="bg-warning bg-opacity-25 p-2 row">
                                                <Row>
                                                    <Form.Check value="true" id="insuranceProducerInformationAttestation" className="checkbox-lg col-1 d-flex centered" required />
                                                    <Form.Label className="col fs-smaller" >I have read the Application and all questions have been answered in full. I have been given consent by the Primary Applicant to submit this application on their behalf and will keep all consent documents on file as required. </Form.Label>
                                                </Row>
                                            </Form.Group>
                                        </ Col>
                                        <Col xl={5}>
                                            <Form.Label className='fw-medium'>Agent Name/NPN *</Form.Label>
                                            <Row>
                                                <Col>
                                                    <Form.Control id="insuranceAgentName" type="text" className='mb-1' placeholder='Agent Full Name' required />
                                                </Col>
                                                <Col>
                                                    <Form.Control id="insuranceAgentNpn" type="text" className='mb-1' placeholder='Agent NPN#' required />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                        <Col sm={12} className='text-end mt-3'>
                            <Button type="button" onClick={clearForm} variant="secondary">Reset</Button> <Button type="Submit" variant="primary" > Submit application </Button>
                        </Col>
                    </Row>
                    <Instructions type="fixed-right" id="instructionsfloatright" />
                </Form>
            </Container>
        </section >
    )
}

export default Application;
